import { render } from "./SupplierSectionAddress.vue?vue&type=template&id=2782edc0"
import script from "./SupplierSectionAddress.vue?vue&type=script&lang=js"
export * from "./SupplierSectionAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__